import React, {useState} from 'react'
import {IconButton, Tooltip} from '@mui/material'
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded'
import {useTranslation} from 'react-i18next'
import RatesCalendarPreviewDialog from './RatesCalendarPreviewDialog'

const RatesCalendarPreviewAction = ({size = 'medium', title}) => {
    const {t} = useTranslation()
    const [open, setOpen] = useState(false)
    const tooltipLabel =
        title ||
        t('rates.calendar.preview.actionButton', {
            defaultValue: 'Preview calendar',
        })

    return (
        <>
            <Tooltip title={tooltipLabel}>
                <IconButton
                    onClick={() => setOpen(true)}
                    aria-label={tooltipLabel}
                    size={size}>
                    <VisibilityRoundedIcon fontSize="inherit" />
                </IconButton>
            </Tooltip>
            <RatesCalendarPreviewDialog open={open} onClose={() => setOpen(false)} />
        </>
    )
}

export default RatesCalendarPreviewAction
